<template>
    <div class="dokan-logical-container">
        <ul>
            <li class="dokan-logical-label-li">
                <div class="level-condition">
                    {{ __( 'Announce this badge', 'dokan' ) }}
                    <div class="input-group">
                        <span class="input-group-text">
                            <i class="icon" :class="getBadgeEvent().input_group_icon.condition"></i>
                        </span>
                        <select class="form-control" v-model.lazy="badge_levels[0].level_condition">
                            <option value="week">{{ __('Weekly', 'dokan') }}</option>
                            <option value="month">{{ __('Monthly', 'dokan') }}</option>
                        </select>
                    </div>
                    {{ __( 'based on top', 'dokan' ) }}
                    <div class="input-group">
                        <span class="input-group-text">
                            <i class="icon" :class="getBadgeEvent().input_group_icon.data"></i>
                        </span>
                        <input class="form-control" type="number" min="10" setp="1" v-on:change="setLevelData()" v-model.lazy="badge_levels[0].level_data">
                    </div>
                    {{ __( 'best selling products.', 'dokan' ) }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import defaultBadgeLevelData from '../../../BadgeLevel.json';

export default {
    name: 'TrendingProduct',

    props: {
        event: {
            type: Object,
            default () {
                return this.getDefaultBadgeLevels();
            },
        },
    },

    data () {
        return {
            badge_levels: this.getLevels(),
        }
    },

    inject: ['setBadgeLevels', 'getBadgeLevels', 'getBadgeEvent'],

    methods: {
        getLevels() {
            if ( ! this.getBadgeLevels().length ) {
                return this.getDefaultBadgeLevels();
            }
            return this.getBadgeLevels();
        },

        getDefaultBadgeLevels() {
            defaultBadgeLevelData.level_condition = 'week';
            defaultBadgeLevelData.level_data = 5;
            return [
                Object.assign( {}, defaultBadgeLevelData ),
            ]
        },

        setLevelData() {
            const current_value = parseInt( this.badge_levels[0].level_data );
            if ( current_value < 1 || isNaN(current_value) ) {
                this.badge_levels[0].level_data = 1;
            }
        },
    },

    created () {
        this.$watch('badge_levels', (newLevels) => {
            this.setBadgeLevels( [ this.badge_levels[0] ] );
        });
    },

    updated () {

    },

    activated() {
        // keep-alive
        // called on initial mount
        // and every time it is re-inserted from the cache
        this.setBadgeLevels( [ this.badge_levels[0] ] );
    },

    deactivated() {
        // keep-alive
        // called when removed from the DOM into the cache
        // and also when unmounted
    },
}
</script>

<style lang="less" scoped>
    .dokan-logical-container {
        .level-condition {
            display: flex;
            align-items: center;
            gap: 10px;

            @media (max-width: 767px) {
                align-items: start;
                flex-direction: column;
            }
        }

        select,
        input {
            border: 1px solid #e2e2e2;
            border-radius: 3px;
            height: 42px ;
            font-size: 15px;
            width: 145px;
        }
    }
</style>
